import React, { useContext, useState, useEffect } from 'react';
import { API_URL } from '../config/apiConfig';
import { AuthContext } from '../context/AuthContext';
import { Container, Typography, Button, Box, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const RoleSelectionPage = () => {
    const navigate = useNavigate();
    const { token, setRole, setIsTrainer } = useContext(AuthContext); // Lisa setIsTrainer
    const [affiliateOwner, setAffiliateOwner] = useState(false);
    const [isTrainer, setIsTrainerLocal] = useState(false);
    const [error, setError] = useState('');
    // API_URL imported from config

    useEffect(() => {
        // Laeme /api/auth/me
        fetch(`${API_URL}/auth/me`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.error) {
                    setError(data.error);
                } else {
                    setAffiliateOwner(data.affiliateOwner);
                    const trainerStatus = !!data.isTrainer;
                    setIsTrainerLocal(trainerStatus);

                    // MUUTUS: Kasuta AuthContext'i setIsTrainer funktsiooni
                    setIsTrainer(trainerStatus);

                    // Auto-select "regular" role and redirect if both affiliateOwner and isTrainer are false
                    if (!data.affiliateOwner && !data.isTrainer) {
                        setRole('regular');
                        navigate('/training-diary');
                    }
                }
            })
            .catch((err) => {
                console.error(err);
                setError('Failed to load user info');
            });
    }, [navigate, token ]); // Lisa setIsTrainer dependency'sse

    const handleRoleSelect = (role) => {
        // Checkin puhul saada 'affiliate' roll serverisse
        const serverRole = role === 'checkin' ? 'affiliate' : role;

        // Saada roll serverisse
        fetch(`${API_URL}/auth/role`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ role: serverRole })
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    setError(data.error);
                    return;
                }

                // Kui edukalt salvestatud, siis sea role ja navigeeri
                setRole(role); // Frontend'is jääb 'checkin'

                if (role === 'regular') {
                    navigate('/training-diary');
                } else if (role === 'affiliate') {
                    navigate('/affiliate-owner');
                } else if (role === 'trainer') {
                    navigate('/trainer');
                } else if (role === 'checkin') {
                    navigate('/checkin');
                }
            })
            .catch(err => {
                console.error(err);
                setError('Rolli salvestamine ebaõnnestus');
            });
    };

    if (error) {
        return (
            <Container sx={{ mt: 4 }}>
                <Alert severity="error">{error}</Alert>
            </Container>
        );
    }

    return (
        <Container sx={{ mt: 4 }}>
            <Typography variant="h4" gutterBottom>
                Select Your Role
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 300 }}>
                {affiliateOwner ? (
                    <>
                        {/* Kui kasutaja on Affiliate Owner, kuva ainult Affiliate Owner ja Check-In */}
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => handleRoleSelect('affiliate')}
                        >
                            Affiliate Owner
                        </Button>
                        <Button
                            variant="contained"
                            color="warning"
                            onClick={() => handleRoleSelect('checkin')}
                        >
                            Check-in
                        </Button>
                    </>
                ) : (
                    <>
                        {/* Muidu kuva Regular User ja Trainer (kui on trainer) */}
                        <Button variant="contained" color="primary" onClick={() => handleRoleSelect('regular')}>
                            Regular User
                        </Button>

                        {/* Kuvame Trainer valiku ainult siis, kui isTrainer = true */}
                        {isTrainer && (
                            <Button
                                variant="contained"
                                color="success"
                                onClick={() => handleRoleSelect('trainer')}
                            >
                                Trainer
                            </Button>
                        )}
                    </>
                )}
            </Box>
        </Container>
    );
};

export default RoleSelectionPage;